<template>
  <div class="text-xs-center">
    <v-dialog
      v-model="dialog"
      hide-overlay
      persistent
      width="300"
    >
      <v-card
        color="primary"
        dark
      >
        <v-card-text>
          Espere un momento por favor
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
    import axios from "axios"
    import config from './../../../config/env.example'
    import {RoutesStorage} from '@/helpers/storage'

  export default {
    data () {
      return {
        dialog: true,
        routesStorage:new RoutesStorage(),
        identity: null,
        session: false,
        token: null,
        iduser: '',
      }
    },
    
    mounted(){
        this.iduser = this.$route.params.id
        if(!this.session || this.iduser !== null || this.iduser !== ''){
            //console.log(this.$route.params.id)
            

            setTimeout(() => (
                    
                    axios.get(`${config.serverweb}localstorage/${this.iduser}`)
                    .then((res)=>{
                        this.identity = res.data.userdata.user
                        this.token = res.data.userdata.token
                        //console.log(this.token)

                    
                        setTimeout(() => {
                            this.saveIdentity()
                            window.location  =   this.routesStorage.get()?this.routesStorage.get().login:'/'||'/'
                        }, 400)
                    })
                    .catch((err) => {
                        console.log(err)
                    })

                ), 4000)
            }else{
              window.location('/')
            }
        
    },
    methods:{
        /****************** * Guardar datos para identificar si el usuarios ha iniciado sesión ***************************************************+*/
        saveIdentity() {
            this.$store.dispatch('saveIdentity', this.identity)
            localStorage.setItem('iden', JSON.stringify(this.identity))
            this.$store.dispatch('saveToken', this.token)
            localStorage.setItem('tok', this.token)
        },
    }
    
  }
</script>
